import Vue from 'vue';
import {Vue2Storage} from 'vue2-storage';

const config_ = {
	prefix: 'appLocalStorage',
	driver: 'local',
	ttl: 0 // ms
}

Vue.use(Vue2Storage, config_)
